export function dataInRequest(params = {}) {
  return {
    type: '@pitStopRegra/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@pitStopRegra/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@pitStopRegra/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@pitStopRegra/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@pitStopRegra/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@pitStopRegra/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@pitStopRegra/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@pitStopRegra/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@pitStopRegra/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@pitStopRegra/RECORD_FILTERING',
    payload: { params },
  };
}
